/* 🤖 this file was generated by svg-to-ts */
export const iconLineasepolia: {
  name: 'lineasepolia';
  data: string;
} = {
  name: 'lineasepolia',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><path fill="currentColor" d="M16 0C7.16 0 0 7.16 0 16s7.16 16 16 16 16-7.16 16-16S24.84 0 16 0m5.23 24.32H7.99V10.37h3.03v11.25h10.21zm0-11.24c-1.49 0-2.7-1.21-2.7-2.7s1.21-2.7 2.7-2.7 2.7 1.21 2.7 2.7-1.21 2.7-2.7 2.7"/></svg>`,
};
